<template>
    <div style="height: 100%;">
        <!-- 큰화면 -->
        <v-container fluid :style="!displayDialog?'height:100%;':'padding: 0px; flex-direction: column; display: flex; justify-content: center; align-items: center;'">
            <div class="mb-2 pa-4 d-flex align-center" style="height: 20%; border-bottom: 1px solid rgba(0,0,0,.12);">
                <v-toolbar elevation="0">
                    <div class="d-flex flex-column">
                        <v-toolbar-title style="font-size: 25px; font-weight: 700 !important;">Scanner</v-toolbar-title>
                        <div>Configure and launch a new vulnerability scan</div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn
                    color="success"
                    elevation="0"
                    v-if="isScan && !addLogin"
                    @click="crawlerStart()"
                    style="height: 100%;"
                    >
                        <v-icon
                        small
                        class="mr-2"
                        >
                            mdi-scan-helper
                        </v-icon>
                        start SCAN
                    </v-btn>
                </v-toolbar>
            </div>
            <!-- <div v-if="!displayDialog" style="height: 10%;">
                <v-card style=" padding: 15px; z-index: 10;" :elevation="expand?2:4" >
                    <div>
                        <div @click="expand = !expand" class="d-flex flex-row justify-left align-center" style="width: 100%;">
                            <div class="font-weight-bold pa-0" style="font-size: 20px;">Scanner</div>
                            <div v-if="errorMessage" style="color: red; white-space: nowrap; margin-left: 20px;">
                                    {{ errorMessage }}
                            </div>
                            <v-btn icon  style="position: absolute; right: 20px;" @click.stop="expand = !expand">
                                <img src="@/assets/chevron-down.svg">
                            </v-btn>
                        </div>
                        <div v-if="!expand" class="d-flex flex-row pt-1 align-center justify-left" style="width: 100%;">
                            <v-text-field
                            label="Enter URL to scan"
                            outlined
                            clearable
                            dense
                            v-model="currentScanUrl"
                            class="textField"
                            placeholder="Enter URL to scan"
                            hide-details
                            @keypress.enter="crawlerStart()"
                            ></v-text-field>
                            <v-btn
                            color="success"
                            id="scanBtn"
                            elevation="0"
                            v-if="isScan && !addLogin"
                            @click="crawlerStart()"
                            >
                                SCAN
                            </v-btn>
                        </div>
                        <div  v-if="!expand" class="pt-0 pb-1 pl-1">
                            <v-btn dense text small class="textBtn" @click="addLoginInfo">
                                + Add Login Information
                            </v-btn>
                        </div>
                    </div>

                    <div class="ma-4 mt-0 d-flex flex-row" v-if="addLogin && !expand">
                        <div id="addAccount" style="width: 100%; gap: 7px;" class="d-flex flex-column">
                            <div class="d-flex flex-row justify-left" style="width: 100%; gap:5px;" v-for="(acc, index) in accountArr" :key="index">
                                <div class="d-flex flex-row" style="width: 80%; gap: 5px; position: relative;">
                                    <v-text-field
                                    label="Login URL"
                                    outlined
                                    clearable
                                    dense
                                    v-model="acc.login_url"
                                    class="textField"
                                    style="max-width: 30% !important; margin-right: 0px !important;"
                                    placeholder="Login URL"
                                    hide-details
                                    ></v-text-field>
                                    <div class="d-flex flex-row justify-center" style="gap: 5px; width: 40%;">
                                        <v-text-field
                                        label="ID"
                                        outlined
                                        clearable
                                        v-model="acc.auth_id"
                                        dense
                                        class="textField"
                                        style="margin-right: 0px !important;"
                                        placeholder="ID"
                                        hide-details
                                        ></v-text-field>
                                        
                                        <v-text-field
                                        label="Password"
                                        outlined
                                        clearable
                                        dense
                                        v-model="acc.auth_pw"
                                        type="password"
                                        class="textField"
                                        style="margin-right: 0px !important;"
                                        placeholder="Password"
                                        hide-details
                                        ></v-text-field>
                                    </div>
                                    
                                    <v-text-field
                                    v-if="index==0"
                                    label="Enter Login API to scan"
                                    outlined
                                    clearable
                                    dense
                                    append-icon="mdi-help-circle"
                                    ref="appendIcon"
                                    v-model="acc.api_url"
                                    class="textField"
                                    style="max-width: 30% !important; margin-right: 0px !important;"
                                    placeholder="Enter Login URL to scan"
                                    hide-details
                                    ></v-text-field>
                                    
                                    <v-text-field
                                    v-if="index>0"
                                    label="Enter Login API to scan"
                                    outlined
                                    clearable
                                    dense
                                    v-model="acc.api_url"
                                    class="textField"
                                    style="max-width: 30% !important; margin-right: 0px !important;"
                                    placeholder="Enter Login URL to scan"
                                    hide-details
                                    ></v-text-field>
                                    <div id="apiHelp" v-if="apiToggle && index==0">
                                        Enter if the SPA(Single Page Application) uses a different domain for the backend API.
                                    </div>
                                </div>
                                <div class="d-flex align-center" style="width: 20%;">
                                    <v-btn icon small @click="removeOne(index)">
                                        <img src="@/assets/minus.svg">
                                    </v-btn>
                                    <v-btn icon small @click="addOne(index)" v-if="index === accountArr.length-1">
                                        <img src="@/assets/plus.svg">
                                    </v-btn>
                                    <div class="ml-2" v-if="index === accountArr.length-1">
                                        <v-btn color="success" id="scanBtn" elevation="0" v-if="isScan" @click="crawlerStart()">
                                            SCAN
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </div> -->
            <!-- 모바일 화면 -->
            <!-- <div v-else style="height: 100%;width: 100%;">
                <v-card outlined style=" width: 100%; padding: 15px; z-index: 10; border: transparent;" elevation=4>
                    <div>
                        <div class="d-flex flex-row justify-left align-center" style="width: 100%;" >
                            <div class="font-weight-bold pa-0" style="font-size: 20px;">Scanner</div>
                            <div v-if="errorMessage" style="color: red; white-space: nowrap; margin-left: 20px;">
                                    {{ errorMessage }}
                            </div>
                            <v-btn icon  style="position: absolute; right: 20px;" @click="expand = !expand">
                                <img src="@/assets/chevron-down.svg">
                            </v-btn>
                        </div>
                        <div v-if="!expand" class="d-flex flex-row pt-1 align-center justify-left" style="width: 100%;">
                            <v-text-field
                            label="Enter URL to scan"
                            outlined
                            clearable
                            dense
                            v-model="currentScanUrl"
                            class="textField"
                            placeholder="Enter URL to scan"
                            hide-details
                            @keypress.enter="crawlerStart()"
                            ></v-text-field>
                        </div>
                        <div  v-if="!expand" class="pt-0 pb-1 pl-1">
                            <v-btn dense text small class="textBtn" @click="addLoginInfo">
                                + Add Login Information
                            </v-btn>
                        </div>
                    </div>

                    <div class="mt-0 mb-2 d-flex flex-row" v-if="addLogin && !expand">
                        <div id="addAccount" style="width: 100%; gap: 7px;" class="d-flex flex-column">
                            <div class="d-flex flex-column justify-left pa-2" style="width: 100%; background-color: #cfd8dc; border-radius: 4px;" v-for="(acc, index) in accountArr" :key="index">
                                <div class="d-flex align-center justify-left" style="width: 100%;">
                                    <div style="font-size: 0.8em; font-weight: bold; width: 95%;">
                                        Login Information {{ index+1 }}
                                    </div>
                                    <v-btn icon small @click="removeOne(index)" style="width: 20px; height: 20px;">
                                        <img src="@/assets/close.svg">
                                    </v-btn>
                                </div>
                                <div class="d-flex flex-column mt-1" style="width:100%; gap: 7px;">
                                    <v-text-field
                                    label="Login URL"
                                    regular
                                    clearable
                                    dense
                                    background-color="white"
                                    v-model="acc.login_url"
                                    class="textFieldMobile"
                                    style="max-width:100% !important;margin-right: 0px !important; border: transparent !important;"
                                    placeholder="Login URL"
                                    hide-details
                                    ></v-text-field>
                                    <div class="d-flex flex-row justify-center" style="width:100%; gap:5px;">
                                        <v-text-field
                                        label="ID"
                                        regular
                                        clearable
                                        v-model="acc.auth_id"
                                        dense
                                        class="textFieldMobile"
                                        style="margin-right: 0px !important;"
                                        placeholder="ID"
                                        hide-details
                                        ></v-text-field>
                                        
                                        <v-text-field
                                        label="Password"
                                        regular
                                        clearable
                                        dense
                                        v-model="acc.auth_pw"
                                        type="password"
                                        class="textFieldMobile"
                                        style="margin-right: 0px !important;"
                                        placeholder="Password"
                                        hide-details
                                        ></v-text-field>
                                    </div>
                                    
                                    <v-text-field
                                    v-if="index==0"
                                    label="Enter Login API to scan"
                                    regular
                                    clearable
                                    dense
                                    append-icon="mdi-help-circle"
                                    ref="appendIcon"
                                    v-model="acc.api_url"
                                    class="textFieldMobile"
                                    style="max-width: 100% !important; margin-right: 0px !important;"
                                    placeholder="Enter Login URL to scan"
                                    hide-details
                                    ></v-text-field>
                                    
                                    <v-text-field
                                    v-if="index>0"
                                    label="Enter Login API to scan"
                                    regular
                                    clearable
                                    dense
                                    v-model="acc.api_url"
                                    class="textFieldMobile"
                                    style="max-width: 100% !important; margin-right: 0px !important;"
                                    placeholder="Enter Login URL to scan"
                                    hide-details
                                    ></v-text-field>
                                    <div id="apiHelp" style="position: static; width: 100%;" v-if="apiToggle && index==0">
                                        Enter if the SPA(Single Page Application) uses a different domain for the backend API.
                                    </div>
                                </div>
                                
                                <v-btn small @click="addOne(index)" v-if="accountArr.length<3" style="width: 100%; margin-top: 7px;" elevation="0">
                                    <img src="@/assets/plus.svg" style="width: 20px;">ADD
                                </v-btn>
                            </div>
                        </div>
                    </div>
                    
                    <v-btn
                    color="success"
                    id="scanBtn"
                    style="width: 100%;"
                    elevation="0"
                    v-if="isScan && !expand"
                    @click="crawlerStart()"
                    >
                        SCAN
                    </v-btn>
                </v-card>
            </div> -->

            <!-- 스캔 결과 화면 -->
            <div style="height: 80%; width:100%; padding: 10px;">
                <v-alert
                v-if="errorMessage"
                color="error"
                border="left"
                type="Warning"
                dismissible
                >
                {{errorMessage}}
                </v-alert>
                <v-card class="pa-4 mb-4" outlined elevation="1">
                    <v-row style="width: 100%" class="d-flex flex-column">
                        <v-col class="d-flex flex-row">
                            <div class="d-flex align-center">
                                <v-chip
                                color="indigo"
                                outlined
                                class="mr-2 pa-2"
                                style="border-radius: 10px !important; height: 80%; background-color: rgba(63,81,181, 0.1) !important;"
                                >
                                    <v-icon
                                    >
                                        mdi-web
                                    </v-icon>
                                </v-chip>
                            </div>
                            <div class="d-flex flex-column">
                                <div class="text-h6">Target URL</div>
                                <div>The website to scan for security vulnerabilities</div>
                            </div>
                            <v-spacer></v-spacer>
                            <div style="height: 100%;">
                                <v-chip
                                outlined
                                color="error"
                                style="background-color: rgba(229,57,53, 0.1) !important;"
                                >
                                Required
                                </v-chip>
                            </div>
                        </v-col>
                        <v-col>
                            <v-text-field
                            placeholder="https://example.com"
                            outlined
                            dense
                            v-model="scanUrl"
                            clearable
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>

                <!-- login information 부분 -->
                <v-card class="pa-4" outlined elevation="1" style="min-height: 15%;">
                    <v-row style="width: 100%;" class="d-flex flex-column">
                        <v-col class="d-flex flex-row" style="">
                            <div class="d-flex align-center">
                                <v-chip
                                color="#90A4AE"
                                outlined
                                class="mr-2 pa-2"
                                style="border-radius: 10px !important; height: 100%; background-color: rgba(144,164,174,0.1) !important;"
                                >
                                    <v-icon
                                    >
                                        mdi-account
                                    </v-icon>
                                </v-chip>
                            </div>
                            <div class="text-h6">Login Information</div>
                            <v-spacer></v-spacer>
                                <v-chip
                                outlined
                                color="#78909C"
                                style="background-color: rgba(144,164,174,0.1) !important;"
                                >
                                Optional
                                </v-chip>
                        </v-col>
                        <v-col class="d-flex flex-row">
                            <div 
                            class="d-flex flex-row"
                            style="width: 100%;"
                            >
                                <v-card 
                                outlined 
                                elevation="1" 
                                style="background-color: #ECEFF1; width: 100%;"
                                >
                                    <v-row 
                                    no-gutters 
                                    style="padding: 12px; padding-top: 0px;"
                                    :class="displayDialog?'d-flex flex-column':'d-flex flex-row'"
                                    >
                                        <v-col :cols="displayDialog?12:6" :class="displayDialog?'pa-1':'pa-3 pb-0'">
                                            <div class="text-caption mb-1 pl-1">
                                                Login URL
                                            </div>
                                            <v-text-field
                                            placeholder="https://example.com/login"
                                            outlined
                                            dense
                                            clearable
                                            hide-details
                                            style="background-color: white;"
                                            v-model="loginUrl"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col :cols="displayDialog?12:3" :class="displayDialog? 'pa-1':'pt-3 pr-3'">
                                            <div class="text-caption mb-1 pl-1">
                                                ID
                                            </div>
                                            <v-text-field
                                            placeholder="ID"
                                            outlined
                                            dense
                                            v-model="loginId"
                                            clearable
                                            hide-details
                                            style="background-color: white;"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col :cols="displayDialog?12:3" :class="displayDialog? 'pa-1':'pt-3'">
                                            <div class="text-caption mb-1 pl-1">
                                                Password
                                            </div>
                                            <v-text-field
                                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show1 ? 'text' : 'password'"
                                            placeholder="Password"
                                            outlined
                                            dense
                                            v-model="loginPw"
                                            clearable
                                            hide-details
                                            style="background-color: white;"
                                            @click:append="show1 = !show1"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col 
                                        :cols="displayDialog?12:6" 
                                        :class="displayDialog? 'pa-1':'pa-3 pb-0'" 
                                        style="position: relative;"
                                        >
                                            <div class="text-caption mb-1 pl-1 d-flex align-center">
                                                <div>
                                                    Login API
                                                </div>
                                                <v-spacer></v-spacer>
                                                <v-card id="apiHelp" outlined class="text-caption pa-1" v-if="apiToggle">
                                                    Enter if the SPA(Single Page Application) uses a different domain for the backend API.
                                                </v-card>
                                            </div>
                                            <v-text-field
                                            placeholder="/api/auth/login"
                                            outlined
                                            v-model="loginApi"
                                            dense
                                            append-icon="mdi-help-circle"
                                            ref="appendIcon"
                                            clearable
                                            hide-details
                                            style="background-color: white;"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </div>
                            <!-- 여러 로그인 인포메이션 -->
                            <!-- <div 
                            v-for="(acc, idx) in accountArr"
                            :key="idx"
                            class="d-flex flex-row"
                            >
                                <v-card 
                                outlined 
                                elevation="1" 
                                style="background-color: #ECEFF1;"
                                >
                                    <div style="padding: 20px; padding-bottom: 0px;" class="d-flex flex-row align-center">
                                       <div style="font-weight: 400; background-color: white; border-radius: 20px; padding:5px 10px; width: fit-content; border: 1px solid lightgrey;">
                                           Login Information #{{ idx+1 }}
                                       </div> 
                                       <v-spacer></v-spacer>
                                       <div>
                                        <v-btn
                                        elevation=""
                                        text
                                        small
                                        color="#757575"
                                        class="text-none removeBtn"
                                        style="border-radius: 20px; padding: 0 10px !important;"
                                        @click="removeOne(idx)"
                                        v-if="accountArr.length>1"
                                        >
                                            <v-icon small>
                                                mdi-trash-can-outline
                                            </v-icon>
                                            Remove
                                        </v-btn>
                                       </div>
                                    </div>
                                    <v-row no-gutters style="padding: 12px; padding-top: 0px;">
                                        <v-col cols="6" class="pa-3 pb-0">
                                            <div class="text-caption mb-1 pl-1">
                                                Login URL
                                            </div>
                                            <v-text-field
                                            placeholder="https://example.com/login"
                                            outlined
                                            dense
                                            clearable
                                            hide-details
                                            ref="appendIcon"
                                            style="background-color: white;"
                                            v-model="acc.login_url"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="6" class="pa-3 pb-0">
                                            <div class="text-caption mb-1 pl-1">
                                                Login API
                                            </div>
                                            <v-text-field
                                            placeholder="/api/auth/login"
                                            outlined
                                            v-model="acc.api_url"
                                            dense
                                            ref="appendIcon"
                                            clearable
                                            hide-details
                                            style="background-color: white;"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="6" class="pa-3">
                                            <div class="text-caption mb-1 pl-1">
                                                ID
                                            </div>
                                            <v-text-field
                                            placeholder="ID"
                                            outlined
                                            dense
                                            ref="appendIcon"
                                            v-model="acc.auth_id"
                                            clearable
                                            hide-details
                                            style="background-color: white;"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="6" class="pa-3">
                                            <div class="text-caption mb-1 pl-1">
                                                Password
                                            </div>
                                            <v-text-field
                                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                             :type="show1 ? 'text' : 'password'"
                                            placeholder="Password"
                                            outlined
                                            dense
                                            ref="appendIcon"
                                            v-model="acc.auth_pw"
                                            clearable
                                            hide-details
                                            style="background-color: white;"
                                            @click:append="show1 = !show1"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-btn 
                                outlined 
                                small 
                                color="#90A4AE"
                                style="height: 100%; margin-left: 10px; font-size: 30px; width: 30px; padding: 0px !important;background-color: rgba(144,164,174,0.1) !important;"
                                @click="addOne(idx)"
                                >
                                    +
                                </v-btn>
                                
                            </div> -->
                        </v-col>
                    </v-row>
                </v-card>
                <!-- <scan-result-vue 
                    v-show="scanResult" 
                    :result="resultObj" 
                    :infoObj="infoObj"
                    :owaspData="owaspArr"
                >
                </scan-result-vue> -->
                <!-- 큐에 남아있는 스캔 건 수 출력 -->
                <!-- <v-card v-if="curLeft > 0 && curStatus != null" elevation="0" style="height: 100% !important; padding: 0px !important;">
                    <v-container style="height: 100%">
                        <v-row
                            class="fill-height"
                            align-content="center"
                            justify="center"
                        >
                            <v-col
                                class="text-h5 font-weight-medium text-center"
                                cols="12"
                                style="padding-bottom: 0px !important;"
                            >
                                There are <strong>{{ curLeft }}</strong> scans left.
                            </v-col>
                            <v-col
                                class="text-subtitle-1 text-center"
                                cols="12"
                                style="padding-top: 0px !important;"
                            >
                                It takes time to scan, so please wait for prior scans.
                            </v-col>
                            <v-col cols="6">
                                <v-progress-linear
                                    color="orange"
                                    indeterminate
                                    rounded
                                    height="10"
                                ></v-progress-linear>
                            </v-col>
                            
                            <v-col cols="12" style="text-align: center;">
                                <v-btn
                                color="error"
                                elevation="0"
                                @click="stopScan()"
                                >
                                    stop scanning
                                </v-btn>
                            </v-col>
                        </v-row>
                        
                    </v-container>
                </v-card> -->
                <!-- 스캔 진행 중 화면 -->
                <!-- <v-card v-if="curLeft==0 && !scanResult && curStatus!=100 && curStatus!=null && curStatus !='null' && timeTaken != 'undefined'" elevation="0"  style="height: 100% !important;">
                    <v-container style="height: 100%">
                        <v-row
                            class="fill-height"
                            align-content="center"
                            justify="center"
                        >
                            <v-col
                                class="text-h4 font-weight-medium text-center"
                                cols="12"
                            >
                                {{timeTaken}}
                            </v-col>
                            <v-col
                                class="text-h5 font-weight-medium text-center"
                                cols="12"
                                style="padding-bottom: 0px !important;"
                            >
                                Scanning for vulnerabilities.
                            </v-col>
                            <v-col
                                class="text-subtitle-1 text-center"
                                cols="12"
                                style="padding-top: 0px !important;"
                            >
                                It takes time to scan, so please wait for scan result.
                            </v-col>
                            <v-col cols="6">
                                <v-progress-linear
                                    color="orange"
                                    indeterminate
                                    rounded
                                    height="10"
                                ></v-progress-linear>
                            </v-col>
                            <v-col
                                class="text-h5 font-weight-medium text-center"
                                cols="12"
                                style="padding-bottom: 0px !important;"
                            >
                                {{curStatus}} %
                            </v-col>
                            <v-col style="text-align: center;">
                                <v-btn
                                color="error"
                                elevation="0"
                                @click="stopScan()"
                                >
                                    stop scanning
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card> -->
            </div>
        </v-container>
    </div>
</template>

<script>
// import scanResultVue from './scanResult.vue';
import "highlight.js/styles/github.css";
import EventBus from '@/plugins/EventBus';
// import { address } from '@/mixins/api';
import Swal from 'sweetalert2';
import axios from "axios";

export default {
    name: 'ScanPage',
    components: {
        // scanResultVue
    },
    data: () => ({
        show1:false,
        isScan:true,
        addLogin:false,
        addaccount:false,
        accountArr:[{auth_id:null, auth_pw:null, login_url: null, api_url: null}],
        drawer:false,
        loginId:null,
        loginPw:null,
        loginUrl:null,
        loginInput:false,
        loginApi:null,
        scanUrl: null,
        currentScanUrl: null,
        scanCompleted: false,
        scanResult: false,
        errorMessage: '',
        resultObj: [],
        startTime:null,
        scanId: null,
        apiToggle:false,
        infoObj:null,
        owaspArr:null
    }),
    methods:{
        addLoginInfo:function(){
            this.loginInput=true;
            this.addLogin = !this.addLogin
            this.accountArr.length=0;
            this.accountArr.push({auth_id:null, auth_pw:null, login_url: null, api_url: null});
            this.$nextTick(()=>{
                const appendIcon = this.$refs.appendIcon[0];
                appendIcon.$el.querySelector('.mdi-help-circle').addEventListener('mouseover',()=>{this.apiToggle=true});
                appendIcon.$el.querySelector('.mdi-help-circle').addEventListener('mouseout',()=>{this.apiToggle=false});
                appendIcon.$el.querySelector('.mdi-help-circle').addEventListener('touchstart',()=>{this.apiToggle=true});
                appendIcon.$el.querySelector('.mdi-help-circle').addEventListener('touchend',()=>{this.apiToggle=false});
            })
        },
        addOne:function(index){
            if(index<2){
                this.accountArr.push({auth_id:null, auth_pw:null, login_url: null, api_url: this.accountArr[index].api_url});
            }
        },
        removeOne:function(index){
            this.accountArr.splice(index,1);
            if(index==0 && this.accountArr.length==0){
                this.addLogin=false;
                this.accountArr.push({auth_id:null, auth_pw:null, login_url: null, api_url: null});
            }
        },
         //스캔 시작되기 전에 3초 지연을 추가했기 때문에 로딩 컴포넌트가 바로 표시되지 않아서 이 로딩 컴포넌트를 추가하기 위해 다른 메서드를 추가했음.
        crawlerStart: function(){
            const url = this.scanUrl.replace(/\s/g, "");
            if(this.isValidUrl(url)){
                this.scanResult = false;
                // this.expand=false;
                // this.isScan=false;
                // this.$store.commit("setScanStatus", 0);
                // this.$store.commit("setCurResult", undefined);
                this.spiderStart1()
            }else{
                this.errorMessage="Please enter a valid URL starting with 'http' or 'https'";
                // alert("Please enter a valid URL starting with 'http' or 'https'");
                return;
            }
        },
        
        spiderStart1: async function(){
            this.scanResult = false;
            this.errorMessage = '';
            this.resultObj = [];
            this.findings = 0;
            const param= [];
            // 스캔할 데이터 정리
            if(this.loginUrl || this.loginApi || this.loginId || this.loginPw){
                param.push({
                    url:this.scanUrl,
                    login_url: this.loginUrl,
                    auth_id: this.loginId,
                    auth_pw: this.loginPw,
                    api_url: this.loginApi
                })
            }else{
                param.push({
                    url:this.scanUrl,
                    login_url: null,
                    auth_id: null,
                    auth_pw: null,
                    api_url: null
                });
            }
            console.log(param);
            // EventBus.$emit("start-scan", param);
            const res = await axios.post(`${this.$apiUrl}/webscan/start`, param, { withCredentials: true });
            console.log(res);
            // 데이터 spider 단계에서 실패
            if(res.data.error){
                var message = '';
                var error = res.data.error
                switch(error){
                    case "session cannot check":
                        message = 'Session validation failed. Please check your session.';
                        break;
                    case "url not valid":
                        message = error;
                        break;
                    case "Target Site cannot access, Please check URL." :
                        message = error;
                        break;
                    default:
                        message = "Unexpected error";
                        break;
                }
                this.errorMessage = message;
            }
            if(res.data.scan_id){
                this.expand=false;
                this.scanUrl=null;
                this.loginUrl=null;
                this.loginApi=null;
                this.loginId=null;
                this.loginPw=null;
                this.errorMessage = '';
                Swal.fire({
                    title: 'Scan started successfully.',
                    text: "The scan progress can be checked in the History menu.",
                    icon: 'success',
                    width: '400px',
                    confirmButtonText:'OK',
                    confirmButtonColor: '#4CAF50',
                    customClass:{
                        confirmButton: 'scan-confirm-button'
                    }
                })
                // .then(()=>{
                //     this.$router.go();
                //     // EventBus.$emit('createClose')
                // })
            }
        },

        stopScan: async function(){
            EventBus.$emit("stop-scan");
            this.isScan=true;
            this.expand=false;
        },

        showError(message) {
            console.log('Error:', message);
            this.errorMessage = message;
            this.expand=false;
            this.isScan=true;
        },
        
        //url http로 시작하는지 맞는 형식을 http:// -> 사이트 이름 -> 도메인 가지고 있는지 확인
        isValidUrl: function(string) {
            try {
                let url = new URL(string);
                if (url.protocol !== "http:" && url.protocol !== "https:") {
                    return false;
                }
                if (!url.hostname || url.hostname.indexOf('.') === -1) {
                    return false;
                }
                const regex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(:\d+)?(\/[^\s]*)?$/;
                if (!regex.test(string)) {
                    return false;
                }
                return true;
            } catch (_) {
                return false;
            }
        },
        //스캔 중이라면 페이지 나가고 싶으면 alert 확인
        handleBeforeUnload(event) {
            if (localStorage.getItem('scanRunning') === 'true') {
                const message = 'A scan is currently in progress. Are you sure you want to leave? Changes may not be saved.'
                event.preventDefault();
                event.returnValue = message;
                return message;
            }
        }
    },

    //스캔 중에 페이지 갔다 왔으면 스캔 결과 이상 없이 결과 표시하기 위한
    beforeRouteLeave(to, from, next) {
        this.resultObj = [];
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        next();
    },
    created(){
        this.resultObj=null;
        this.expand=false;
        this.scanResult=false;
        console.log("scan> created");
        console.log(this.curStatus);
        EventBus.$on('stopScan', this.stopStopWatch);
        EventBus.$on('showError', this.showError);
        //스캔 중에서 페이지 갔다 왔으면 다 필오한 값이 저장, 스캔 중에 다시 돌아온다면 값 및 프로세스 계속 진행
        const savedCurStatus = localStorage.getItem("scanStatus");
        const savedTimeTaken = localStorage.getItem("timeTaken");
        const savedCurResult = JSON.parse(localStorage.getItem("scanResult"));

       
        if(savedCurStatus){
            this.$store.commit("setScanStatus", savedCurStatus)
            // this.expand=true;

        }
        if(savedTimeTaken){
            this.$store.commit("setTimeTaken", savedTimeTaken)
        }
        if(savedCurResult){
            this.$store.commit("setCurResult", savedCurResult)
        }

    },
    mounted(){
        const appendIcon = this.$refs.appendIcon;
        appendIcon.$el.querySelector('.mdi-help-circle').addEventListener('mouseover',()=>{this.apiToggle=true});
        appendIcon.$el.querySelector('.mdi-help-circle').addEventListener('mouseout',()=>{this.apiToggle=false});

    },
    beforeDestroy(){
        EventBus.$off('stopScan', this.stopStopWatch)
        EventBus.$off('showError', this.showError);
        localStorage.removeItem("scanResult");
    },
    computed:{
        displayDialog() {
            switch (this.$vuetify.breakpoint.name) {
                case `xs`:
                return true;
                case `sm`:
                return false;
                default:
                return false;
            }
        },
        screenWidth(){
            return this.$vuetify.breakpoint.name;
        },
        curStatus(){
            return this.$store.state.curStatus;
        },
        timeTaken(){
            return this.$store.state.timeTaken;
        },
        curResult(){
            return this.$store.state.curResult;
        },
        curLeft(){
            return this.$store.state.curLeft;
        }
    },
    watch:{
        curResult:{
            handler(newVal){
                if(newVal){
                    if(Array.isArray(newVal)){
                        this.owaspArr = newVal.pop();
                        this.infoObj = newVal.pop();
                        this.resultObj = newVal;
                        this.expand=true;
                        this.scanResult = true;// 결과 화면 출력
                        this.isScan = true;// 스캔 버튼 활성화
                        this.$store.commit("setCurResult", undefined);
                        this.$store.commit("setTimeTaken", undefined);
                        this.$store.commit("setScanStatus", null);
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
.removeBtn:hover{
    background-color: rgba(244,67,54, 0.1);
    color: rgb(244,67,54) !important;
}
#apiHelp{
    color: white;
    text-align: center;
    position: absolute;
    right: 15px;
    top: 0px;
    width: 300px;
    background-color: rgba(0,0,0,.4);
    line-height: 1.2;
    z-index: 100;
}
.loginInput{
    height: 60vh;
}
.URLInput{
    height: 80vh;
}
/* ::v-deep(.textFieldMobile){
    max-width: 350px !important;
    margin-right: 5px;
    border-radius: 4px 4px 0px 0px;
    background-color: white;
}
::v-deep(.textFieldMobile input){
    padding: 7px 0px 6px !important;
    font-size: 14px !important;
}
::v-deep(.textFieldMobile .v-label){
    font-size: 14px !important;
    top: 7px !important;
}
::v-deep(.textFieldMobile .v-text-field__slot label){
    left: 5px !important
}


::v-deep(.textField input){
    padding: 7px 0px 6px !important;
    font-size: 14px !important;
}
::v-deep(.textField .v-label){
    font-size: 14px !important;
    top: 7px !important;
}
::v-deep(.textField){
    max-width: 350px !important;
    margin-right: 5px;
}
::v-deep(.v-input__slot){
    min-height: 32px !important;
    width: inherit !important;
    padding-right: 5px !important;
}
::v-deep(.v-input__append-inner){
    margin-top: 5px !important;
    padding: 0px !important;
    cursor: pointer;
} */
.tdWidth {
    min-width: fit-content;
    width: 200px !important;
}
.v-expansion-panel-header__icon {
    display: none;
}
.fontBlack {
    color: black;
}
.darkGreen {
    filter: invert(43%) sepia(74%) saturate(436%) hue-rotate(73deg) brightness(91%) contrast(83%);
}
.white{
    filter: invert(84%) sepia(100%) saturate(0%) hue-rotate(153deg) brightness(114%) contrast(101%);
}
.v-data-table__wrapper {
    height: 100%;
}
.v-list::-webkit-scrollbar {
    display: none;
}
.noScroll::-webkit-scrollbar {
    display: none;
}
.v-input__append-inner {
    margin-top: 5px !important;
}
#scanBtn{
    font-size: 13px !important;
    padding: 0px !important;
    height: 32px;
}
.textBtn{
    padding: 0px !important;
    height: fit-content !important;
    min-width: fit-content !important;
}
#addAccount::-webkit-scrollbar{
    width: 5px;
}
#addAccount::-webkit-scrollbar-track{
    background: transparent;
}
#addAccount::-webkit-scrollbar-thumb{
    background-color: darkgray;
    border-radius: 5px;
}
</style>